<template>
    <div>
        <div class="uk-child-width-1-3@m uk-child-width-1-2@s uk-grid-small uk-grid-match uk-grid uk-grid-stack"
             uk-grid>

            <form @submit.prevent="formSubmit" class="uk-form-horizontal uk-margin-large-top uk-first-column">
                <div class="uk-margin">
                    <label class="uk-form-label" for="code">{{$t("enter_code")}}</label>
                    <div class="uk-form-controls">
                        <input id="code" :value="code" @input="preventAlpha" placeholder="код" class="uk-input" type="text" name="code"
                               required="" autofocus>
                    </div>
                </div>
                <p class="uk-text-danger" v-if="res_text">{{res_text}}</p>
                <button type="submit" class="uk-button uk-button-large uk-button-primary">
                    {{ $t("continue") }}
                </button>
            </form>

        </div>
    </div>
</template>

<script>
    import User from "@/utils/User";

    export default {
        name: "CheckPinCode",
        props: {
            docsetID: { required: true, type: String },
        },
        data() {
            return {
                code: "",
                res_text: ""
            };
        },
        methods: {
            formSubmit() {
                this.$http.post("/check-pin-code/", {
                    uuid: this.docsetID,
                    code: this.code
                }).then(response => {
                    this.$store.commit("set_user", new User(
                        response.data.token,
                        this.code,
                        this.docsetID
                    ));
                    this.$router.push({ name: "webList", params: this.$route.params });
                }).catch(error => {
                    this.res_text = error.response.data.message;
                });
            },
            preventAlpha(e) {
                if (e.target.value !== "" && !/^[0-9]+$/.test(e.target.value)) {
                    e.target.value = this.code;
                    return
                }
                this.code = e.target.value;
            }
        }
    };
</script>

<style scoped>

</style>